/* istanbul ignore file */
// @flow

import getAppConfig from './getAppConfig';

let config = null;

/**
 * Gets the identity Server config.
 *
 * @return {Object} The identity server config.
 */
const getIdentityServerConfig = () => {
  if (config) return config;

  const appConfig = getAppConfig();

  config = {
    toggles: {
      useMockBff: appConfig.toggles.useMockBff,
    },
    unsecuredAccessTokenCookie: 'icis_uat',
    securedAccessTokenCookie: 'icis_sat',
    secureAccessTokenEndpoint: `${appConfig.urls.bff}/auth/secure`,
    secureAccessTokenRemovalEndpoint: `${appConfig.urls.bff}/auth/logout`,
    authDomain: appConfig.urls.authDomain,
    externalLogoutUrl: `${appConfig.urls.client}/logout`,
    sso: {
      authority: appConfig.urls.identityServer,
      client_id: appConfig.sso.clientId,
      redirect_uri: `${appConfig.urls.client}/loggedIn`,
      silent_redirect_uri: `${appConfig.urls.client}/silentLoginCallback.html`,
      post_logout_redirect_uri: `${appConfig.urls.client}/`,
      response_type: 'id_token token',
      scope: `openid profile`,
      loadUserInfo: false,
      iframeOrigin: appConfig.urls.client,
      silentRequestTimeout: 20000,
    },
  };

  return config;
};

export default getIdentityServerConfig;
